import { QuestionBarcodeComponent } from './question-barcode.component';

export default angular
  .module('sfMobile.components.question-barcode', [
    'sfMobile.components.barcode-button',
    'sfMobile.components.input-barcode',
  ])
  .component('questionBarcode', QuestionBarcodeComponent).name;
